import { __assign } from "tslib";
import rafSchd from 'raf-schd';
import * as React from 'react';
import { useFela } from 'react-fela';
export var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["RIGHT"] = "right";
    Position["BOTTOM"] = "bottom";
    Position["LEFT"] = "left";
})(Position || (Position = {}));
export var RESIZER_OVERLAP = 3;
export var DEFAULT_BOUNDARIES = {
    min: 0,
    max: window.innerWidth,
};
var EventListenerMode = { capture: true };
var getCssPosition = function (pos) {
    switch (pos) {
        case Position.TOP:
            return {
                top: 0,
                left: 0,
                width: '100%',
                height: RESIZER_OVERLAP,
            };
        case Position.RIGHT:
            return {
                top: 0,
                right: RESIZER_OVERLAP * -1,
                width: RESIZER_OVERLAP + 1,
                height: '100%',
            };
        case Position.BOTTOM:
            return {
                bottom: RESIZER_OVERLAP * -1,
                left: 0,
                width: '100%',
                height: RESIZER_OVERLAP,
            };
        case Position.LEFT:
            return {
                top: 0,
                left: 0,
                width: RESIZER_OVERLAP + 1,
                height: '100%',
            };
    }
};
var getNextMousePosition = function (e, pos) {
    switch (pos) {
        case Position.TOP:
            return e.clientY;
        case Position.BOTTOM:
            return e.clientY;
        case Position.RIGHT:
            return e.clientX;
        case Position.LEFT:
            return e.clientX;
    }
};
var getMoveCursor = function (pos) {
    switch (pos) {
        case Position.TOP:
            return 'row-resize';
        case Position.BOTTOM:
            return 'row-resize';
        case Position.RIGHT:
            return 'col-resize';
        case Position.LEFT:
            return 'col-resize';
    }
};
export var Resizer = function (_a) {
    var onResize = _a.onResize, _b = _a.pos, pos = _b === void 0 ? Position.RIGHT : _b, getBoundaries = _a.getBoundaries;
    var css = useFela().css;
    var _c = React.useState(false), moving = _c[0], setMoving = _c[1];
    var previousMousePositionRef = React.useRef(-1);
    var cursor = getMoveCursor(pos);
    function preventGlobalMouseEvents() {
        document.body.style.cursor = cursor;
    }
    function restoreGlobalMouseEvents() {
        document.body.style.cursor = 'default';
    }
    function mousemoveListener(e) {
        var _a;
        e.stopPropagation();
        var nextMousePosition = getNextMousePosition(e, pos);
        var boundaries = (_a = getBoundaries === null || getBoundaries === void 0 ? void 0 : getBoundaries()) !== null && _a !== void 0 ? _a : DEFAULT_BOUNDARIES;
        if (nextMousePosition < boundaries.min || nextMousePosition > boundaries.max) {
            return;
        }
        if (previousMousePositionRef.current >= 0) {
            var moveBy_1 = nextMousePosition - previousMousePositionRef.current;
            var onResizeInternal = function () {
                onResize(moveBy_1);
            };
            rafSchd(onResizeInternal)();
        }
        previousMousePositionRef.current = nextMousePosition;
    }
    function mouseupListener(e) {
        setMoving(false);
        restoreGlobalMouseEvents();
        document.removeEventListener('mouseup', mouseupListener, EventListenerMode);
        document.removeEventListener('mousemove', mousemoveListener, EventListenerMode);
        e.stopPropagation();
    }
    function captureMouseEvents(e) {
        previousMousePositionRef.current = -1;
        setMoving(true);
        preventGlobalMouseEvents();
        document.addEventListener('mouseup', mouseupListener, EventListenerMode);
        document.addEventListener('mousemove', mousemoveListener, EventListenerMode);
        e.preventDefault();
        e.stopPropagation();
    }
    var style = {
        display: 'none',
        tablet: __assign({ display: 'block', position: 'absolute', cursor: cursor, zIndex: 2 }, getCssPosition(pos)),
    };
    var veilStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        cursor: cursor,
        zIndex: 1000,
    };
    return (React.createElement("div", { className: css(style), onMouseDown: captureMouseEvents }, moving && React.createElement("div", { style: veilStyle })));
};
//# sourceMappingURL=Resizer.js.map